<template>
    <selectize class="form-control"
               v-model="selection"
               :options="wards"
               labelField="name"
               valueField="id"
               searchField="name"
               allowEmpty="true">
    </selectize>
</template>
<!--<template>
    <ul class="nav nav-pills">
        <li class="dropdown">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                Ward: <strong>{{selection.name}}        </strong><span class="caret"></span>
            </a>
            <ul class="dropdown-menu">
                <template v-for="ward in wards">
                    <li>
                        <a href="#" @click.prevent.self="SelectWard(ward)">
                            <strong class="text-primary">{{ward.name}}</strong><br />
                        </a>
                    </li>
                </template>
            </ul>
        </li>
    </ul>
</template>-->
<script>
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import SelectableObject from "../../helpers/SelectableObject";
    import { CarehomeDto } from './../../../dto/carehomedto'
    import selectize from './../../corecontrols/selectize/selectize.scp.html'

    export default {
        props: ['carehome', 'value'],
        data: function () {
            return {
                wards: [],
                selection: {}
            }
        },
        watch: {
            selection: function () {
                console.log("Ward Selected", this.selection)
                this.$emit('input', this.selection);
            },
            carehome: function () {
                if (this.carehome) {
                    this.wards = this.carehome.wards;
                    //if (this.wards) {
                    //    this.selection = this.wards[0];
                    //}
                }
            }
        },
        mounted: function () {
            console.log("Ward Combo Mounted", this.carehome.wards)
            
        },
        components: {
            selectize
        },
        //watch: {
        //    'carehome': function () {
        //        console.log("Carehome changed on wardselector ", this.carehome)
        //        if (this.carehome) {
        //            this.wards = this.carehome.wards;
        //            console.log("Carehome changed on wardselector ", this.carehome.wards)
        //            if (this.value) {
        //                for (var ward of this.wards) {
        //                    if (ward.id == this.value) {
        //                        this.SelectWard(ward);
        //                        return;
        //                    }
        //                }
        //            }
        //            else {
        //                if (this.wards && this.wards.length > 0) {
        //                    console.log("Selecting ward 0", this.wards[0])
        //                    this.SelectWard(this.wards[0]);
        //                }

        //            }
        //        }
        //    },
        //    'value': function (wardid) {
        //        console.log("Ward Id changed to", wardid)
        //        for (var ward of this.wards) {
        //            if (ward.id == wardid) {
        //                this.SelectWard(ward);
        //                return;
        //            }
        //        }
        //    }
        //},
        methods: {
            SelectWard: function (ward) {
                console.log("Ward selected", ward.id)
                this.selection = ward;

                this.$props.value = ward.id;
                this.$emit('input', ward.id);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// wardComboSelector.scp.html?11582ee9